const getStaticImageUrl = ({ fileName }: { fileName: string }): string => {
  return `${process.env.NEXT_PUBLIC_CLOUDFRONT_ASSET_URL || ''}/staticImages/${fileName}`;
};

export { getStaticImageUrl };
